import React, { FC } from "react"

import { ICard } from "../../../../../interfaces";
import { CardType } from "../../../../../util/enums";

interface ChallengeCardProps {
    cardData: ICard;
}

const ChallengeCards: FC<ChallengeCardProps> = ({cardData}) => {
    const isThisQuestionCard = cardData.type === CardType.QUESTION;

    const renderChallengeCardTypes = () => {
        return (
            <div className="front_side__challenge" >
                <div className="front_side-question" /> 
                <div className="challenge_card_content_wrapper">
                    <p className={`front_side__challenge-title ${isThisQuestionCard && "visibility_hidden"}`} >{cardData.title}</p>
                    <p className="front_side__challenge-content" style={{lineHeight: "2.5vh"}}>{cardData.content}</p>
                </div>
            </div>
        );
    }

    return (
        <React.Fragment>
            {renderChallengeCardTypes()}
        </React.Fragment>
    );
}

export default ChallengeCards;